import { OpenpanelService } from '../services/openpanel.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CarrierLogoService } from '../services';
import { FaroService } from '../services/faro.service';

@Component({
    selector: 'app-success',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.css'],
    standalone: false
})
export class SuccessComponent implements OnInit {
  sub:any;
  ticketDetails:any;
  rawTicketDetails:any;
  flightData:any;
  bookingData:any;
  constructor(
    private openpanel: OpenpanelService,
    private router: Router,
    private route: ActivatedRoute,
    public carrierLogoService: CarrierLogoService,
    private faroService: FaroService,
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      let data= params['id'];
      let booking=JSON.parse(atob(data));
      this.rawTicketDetails = booking;
      this.bookingData = this.rawTicketDetails

      // ticket_sold = THE conversion. URL payload can be revisited/bookmarked,
      // so dedupe per booking.
      const ref = booking?.booking_reference || booking?.booking_id || String(data).slice(0, 32);
      const dedupeKey = 'op-ticket-sold-' + ref;
      if (!localStorage.getItem(dedupeKey)) {
        localStorage.setItem(dedupeKey, '1');
        // Identify by the same phone-hash scheme itineraryapi's util/openpanel.py
        // uses, so this web session attributes to the same profile as the
        // server-confirmed booking. Field name is defensive (multiple fallbacks)
        // like the rest of this block, since this payload's shape varies by
        // which confirmation path produced it.
        const phone = booking?.customer_billing_details?.phone_number || booking?.phone_number || booking?.phone;
        this.openpanel.identifyByPhone(phone, {
          email: booking?.customer_billing_details?.email || booking?.email,
        }).catch(() => { /* analytics must never break the app */ });
        this.openpanel.track('ticket_sold', {
          amount: booking?.total_amount,
          currency: booking?.currency || 'KES',
          airline: booking?.airline || booking?.carrier
        });
        this.faroService.pushEvent('booking_completed', {
          booking_reference: ref,
          amount: booking?.total_amount,
          currency: booking?.currency || 'KES',
          airline: booking?.airline || booking?.carrier,
        });
      }

    });
  }

}
